import * as React from 'react';
import {Button, Stack} from "@mui/material";
import {useState} from "react";

export type KeyboardProps = {
    onClick: (value: string) => void;
};

const Keyboard: React.FC<KeyboardProps> = (props) => {

    const letterUppercase = [
        ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
        ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
        ["Z", "X", "C", "V", "B", "N", "M"]
    ];

    const letterLowercase = [
        ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
        ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
        ["z", "x", "c", "v", "b", "n", "m"]
    ];

    const num = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

    const [letter, setLetter] = useState(letterUppercase);
    const [capsFlag, setCapsFlag] = useState(true);

    const clickKey = (value: string) => {
        if (value === 'caps') {
            const newCapsFlag = !capsFlag;
            setCapsFlag(newCapsFlag);
            if (newCapsFlag) {
                setLetter(letterUppercase);
            } else {
                setLetter(letterLowercase);
            }
        } else {
            props.onClick(value);
        }
    }

    return (
        <Stack spacing={2}>
            <Stack direction="row" justifyContent="center" spacing={2}>
                {
                    num.map((item, index) => {
                        return (<Button key={index}
                                        variant="outlined"
                                        size={'large'}
                                        onClick={() => clickKey(item)}>{item}</Button>)
                    })
                }
            </Stack>
            <Stack direction="row" justifyContent="center" spacing={2}>
                {
                    letter[0].map((item, index) => {
                        return (<Button key={index}
                                        size={'large'}
                                        variant="outlined" style={{textTransform: 'none'}}
                                        onClick={() => clickKey(item)}>{item}</Button>)
                    })
                }
            </Stack>
            <Stack direction="row" justifyContent="center" spacing={2}>
                {
                    letter[1].map((item, index) => {
                        return (<Button key={index}
                                        size={'large'}
                                        variant="outlined" style={{textTransform: 'none'}}
                                        onClick={() => clickKey(item)}>{item}</Button>)
                    })
                }
            </Stack>
            <Stack direction="row" justifyContent="center" spacing={2}>
                <Button variant="outlined"
                        size={'large'}
                        onClick={() => clickKey("caps")}>CAPS</Button>
                {
                    letter[2].map((item, index) => {
                        return (<Button key={index}
                                        size={'large'}
                                        variant="outlined" style={{textTransform: 'none'}}
                                        onClick={() => clickKey(item)}>{item}</Button>)
                    })
                }
                <Button value={"DEL"}
                        variant="outlined"
                        size={'large'}
                        onClick={() => clickKey("del")}>DEL</Button>
            </Stack>
        </Stack>
    );
}

export default Keyboard;